/**
 * Created by ori on 15/09/16.
 */
import Store from '../store';
import Actions from '../actions';
import {Provider} from 'mobx-react';
import React from 'react';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import tipigoTheme from '../tipigoTheme';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const App = (props) => {
  console.log("PROPS:", props)
    const initialState = typeof window !== 'undefined' &&  window.__INITIAL_STATE__? window.__INITIAL_STATE__ : {};
    const state = Store(initialState);
    const actions = Actions(state);
    //muiTheme={getMuiTheme(darkBaseTheme)}
    return(
      <div>
  	     <MuiThemeProvider muiTheme={getMuiTheme(tipigoTheme)}>
  	    	<Provider state={state} actions={actions}>
  	        	{props.children}
  	    	</Provider>
  	    </MuiThemeProvider>
      </div>
    );
};

export default App



// WEBPACK FOOTER //
// ./src/js/pages/App.js